/**
 * Detect if the Apple Pay JavaScript SDK (1.2+) is loaded.
 * The SDK registers the <apple-pay-button> custom element when loaded.
 */
export const isApplePaySdkLoaded = (): boolean => {
  if (typeof customElements === 'undefined') return false;
  return customElements.get('apple-pay-button') !== undefined;
};
